import React, {ReactNode} from 'react';
import {useAppContext} from "@context/appContext/hooks/useAppContext";
import ErrorBlock from "@ui/errors/errorBlock/ErrorBlock";
import {useTranslation} from 'react-i18next';
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import {logOut} from "@containers/auth/helpers/helpers";

interface IProps {
    children: ReactNode
}

const UserActiveAccess = ({
                        children,
                    }: IProps) => {
    const {t} = useTranslation()

    const {user} = useAppContext()

    if (!user?.active) {
        return (
            <ErrorBlock
            >
                {t('base.noAccessMessage')}
                <ButtonCustom
                    onClick={logOut}
                >
                    {t('auth.logOut')}
                </ButtonCustom>
            </ErrorBlock>
        )
    }

    return (
        <>
            {children}
        </>
    );
};

export default UserActiveAccess;